import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';

const feedbackApiUrl = '/Feedback';

const PostFeedbackRequest = (data) => nzApiAxios.post(feedbackApiUrl, data);

const API = {
  feedback: PostFeedbackRequest
};

export default API;
